import { FormControl, FormGroup } from "@angular/forms";
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { SalesHistoryService } from "./../../../../services/pbm/sales-history.service";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { SalesHistoryCompany } from "src/app/ui/models/domains/pbm/sales-history/sales-history-company";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { ProductType } from "src/app/ui/models/domains/pbm/Benefit/product-type";
import { LoadingService } from "src/app/ui/services/loading.service";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { FilterOption } from "src/app/ui/models/domains/filters/filter-option";
import { FilterOptionType } from "src/app/ui/models/domains/filters/filter-option-type.enum";
import { Toast } from "../../../toast/toast";
import moment from "moment";
import { ProductService } from "src/app/ui/services/pbm/product.service";
import { FilterFormValidator } from "../../sales-histories/validators/filter-form-validator";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { CompanyInfo } from "src/app/ui/models/domains/pbm/companies/company-info";

@Component({
  selector: "financial-statement-company.component",
  templateUrl: "./financial-statement-company.component.html",
  styleUrls: ["./financial-statement-company.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class FinancialStatementCompanyComponent implements OnInit {
  salesHistoryCompany: SalesHistoryCompany;
  company: Company;
  productTypes: ProductType[];
  fiscalNumber: string;
  socialNumber: string;
  dataMask = MaskInput.getDateMask();
  socialNumberMask = MaskInput.getSocialNumberMask();
  cardNumberMask = MaskInput.getCardNumberMask();
  filterForm: FormGroup = new FormGroup({
    startDate: new FormControl(moment().subtract(1, "M").format("DDMMYYYY")),
    endDate: new FormControl(moment().format("DDMMYYYY")),
    productManufacturer: new FormControl(""),
    productType: new FormControl(""),
  });
  dataSource = [];
  displayedColumns: string[] = ["productName", "soldItemCount", "stateName", "networkName", "soldValueCount"];

  constructor(
    private featureViewService: FeatureViewService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private salesHistoryService: SalesHistoryService,
    private productService: ProductService,
    private loadingService: LoadingService,
    private toast: Toast,
    private cdk: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.SalesHistoryCompany, PageViews.SalesHistoriesPageView);

    const paramns = this.activatedRoute.snapshot.queryParams;

    if (!!paramns.b) {
      const ref = this.loadingService.beginLoading();

      this.fiscalNumber = paramns.b;

      const startDateFilter = new FilterOption(FilterOptionType.Text, "startDateFilter", "startDateFilter");
      startDateFilter.setValue(moment().subtract(1, "M").format("DDMMYYYY"));

      const endDateFilter = new FilterOption(FilterOptionType.Text, "endDateFilter", "endDateFilter");
      endDateFilter.setValue(moment().format("DDMMYYYY"));

      const productManufacturerFilter = new FilterOption(FilterOptionType.Text, "productManufacturerFilter", "productManufacturerFilter");
      productManufacturerFilter.setValue("");

      const prouctTypeFilter = new FilterOption(FilterOptionType.Text, "prouctTypeFilter", "prouctTypeFilter");
      prouctTypeFilter.setValue("");

      const fiscalNumberFilter = new FilterOption(FilterOptionType.Text, "fiscalNumberFilter", "fiscalNumberFilter");
      fiscalNumberFilter.setValue(this.fiscalNumber);

      const filters: FilterOption[] = [];
      filters.push(startDateFilter);
      filters.push(endDateFilter);
      filters.push(productManufacturerFilter);
      filters.push(prouctTypeFilter);
      filters.push(fiscalNumberFilter);

      const pagingRequest = new PagingRequest();
      pagingRequest.setStart(1);
      pagingRequest.setEnd(10);
      pagingRequest.setFilters(filters);

      try {
        this.productTypes = await this.productService.getProductTypes();
        this.salesHistoryCompany = await this.salesHistoryService.findSalesHistoryByFiscalNumber(pagingRequest);
        this.dataSource = this.salesHistoryCompany.getcompanySalesHistoryItemList();
        this.company = new Company();
        this.company.setFiscalNumber(this.salesHistoryCompany.getFiscalNumber());
        this.company.setCorporateName(this.salesHistoryCompany.getCorporateName());
        const companyInfo = new CompanyInfo();
        companyInfo.setEmployeeCount(this.salesHistoryCompany.getEmployeeCount());
        this.company.setCompanyInfo(companyInfo);
        this.cdk.detectChanges();
      } catch (error) {
        this.toast.showWarningToast(error);
        this.router.navigate([RoutePath.SearchFinancialStatement]);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.router.navigate([RoutePath.SearchFinancialStatement]);
    }
  }

  onSearch(event) {
    this.navigateToFinancialStatementBeneficiary(event.type, event.searchType, event.search);
  }

  navigateToFinancialStatementBeneficiary(type: number, searchType: number, filterText: string) {
    if (this.hasSearchParam(filterText)) {
      this.router.navigate([RoutePath.FinancialStatementBeneficiary], {
        queryParams: { f: this.fiscalNumber, s: null, ft: filterText, dep: type, searchType: searchType },
      });
    }
  }

  async onFilterChange(): Promise<any> {
    const ref = this.loadingService.beginLoading();

    const filterFormValidator = new FilterFormValidator();

    if (filterFormValidator.validate(this.filterForm).hasErrorMessages()) {
      this.toast.showWarningToast(filterFormValidator.getValidationResult().getErrorMessage());
      this.loadingService.finishLoading(ref);
    } else {
      const startDate = this.filterForm.get("startDate").value;
      const endDate = this.filterForm.get("endDate").value;
      const productManufacturer = this.filterForm.get("productManufacturer").value;
      const productType = this.filterForm.get("productType") ? this.filterForm.get("productType").value : "";

      const startDateFilter = new FilterOption(FilterOptionType.Text, "startDateFilter", "startDateFilter");
      startDateFilter.setValue(moment(startDate, "DD/MM/YYYY").format("DDMMYYYY"));

      const endDateFilter = new FilterOption(FilterOptionType.Text, "endDateFilter", "endDateFilter");
      endDateFilter.setValue(moment(endDate, "DD/MM/YYYY").format("DDMMYYYY"));

      const productManufacturerFilter = new FilterOption(FilterOptionType.Text, "productManufacturerFilter", "productManufacturerFilter");
      productManufacturerFilter.setValue(productManufacturer);

      const prouctTypeFilter = new FilterOption(FilterOptionType.Text, "prouctTypeFilter", "prouctTypeFilter");
      prouctTypeFilter.setValue(productType);

      const fiscalNumberFilter = new FilterOption(FilterOptionType.Text, "fiscalNumberFilter", "fiscalNumberFilter");
      fiscalNumberFilter.setValue(this.fiscalNumber);

      const filters: FilterOption[] = [];
      filters.push(startDateFilter);
      filters.push(endDateFilter);
      filters.push(productManufacturerFilter);
      filters.push(prouctTypeFilter);
      filters.push(fiscalNumberFilter);

      const pagingRequest = new PagingRequest();
      pagingRequest.setStart(1);
      pagingRequest.setEnd(10);
      pagingRequest.setFilters(filters);

      try {
        this.salesHistoryCompany = await this.salesHistoryService.findSalesHistoryByFiscalNumber(pagingRequest);
        this.dataSource = this.salesHistoryCompany.getcompanySalesHistoryItemList();
        this.cdk.detectChanges();
      } catch (error) {
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    }
  }

  async searchMore(): Promise<any> {
    const ref = this.loadingService.beginLoading();
    const startDate = this.filterForm.get("startDate").value;
    const endDate = this.filterForm.get("endDate").value;
    const productManufacturer = this.filterForm.get("productManufacturer").value;
    const productType = this.filterForm.get("productType") ? this.filterForm.get("productType").value : "";

    const startDateFilter = new FilterOption(FilterOptionType.Text, "startDateFilter", "startDateFilter");
    startDateFilter.setValue(moment(startDate, "DD/MM/YYYY").format("DDMMYYYY"));

    const endDateFilter = new FilterOption(FilterOptionType.Text, "endDateFilter", "endDateFilter");
    endDateFilter.setValue(moment(endDate, "DD/MM/YYYY").format("DDMMYYYY"));

    const productManufacturerFilter = new FilterOption(FilterOptionType.Text, "productManufacturerFilter", "productManufacturerFilter");
    productManufacturerFilter.setValue(productManufacturer);

    const prouctTypeFilter = new FilterOption(FilterOptionType.Text, "prouctTypeFilter", "prouctTypeFilter");
    prouctTypeFilter.setValue(productType);

    const fiscalNumberFilter = new FilterOption(FilterOptionType.Text, "fiscalNumberFilter", "fiscalNumberFilter");
    fiscalNumberFilter.setValue(this.fiscalNumber);

    const filters: FilterOption[] = [];
    filters.push(startDateFilter);
    filters.push(endDateFilter);
    filters.push(productManufacturerFilter);
    filters.push(prouctTypeFilter);
    filters.push(fiscalNumberFilter);

    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(this.salesHistoryCompany.getPagingInfo().getEnd());
    pagingRequest.setEnd(10);
    pagingRequest.setFilters(filters);

    try {
      const result = await this.salesHistoryService.findSalesHistoryByFiscalNumber(pagingRequest);
      this.salesHistoryCompany.setPagingInfo(result.getPagingInfo());
      this.salesHistoryCompany.addItems(result.getcompanySalesHistoryItemList());
      this.dataSource = this.salesHistoryCompany.getcompanySalesHistoryItemList();
      this.cdk.detectChanges();
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  backToSearchFinancialStatement(): void {
    this.router.navigate([RoutePath.SearchFinancialStatement]);
  }

  hasSalesHistoryCompany(): boolean {
    return !!this.salesHistoryCompany;
  }

  hasSalesHistoryCompanyItem(): boolean {
    return !!this.salesHistoryCompany && this.salesHistoryCompany.getcompanySalesHistoryItemList().length > 0;
  }

  hasSearchParam(filterText: string): boolean {
    return filterText !== "";
  }

  exportReportToPDF() {
    if (!this.salesHistoryCompany) {
      this.toast.showWarningToast('Nenhum relatório disponível para exportar.');
      return;
    }

    const summary = this.salesHistoryCompany.getSalesHistorySummary();
    const items = this.salesHistoryCompany.getcompanySalesHistoryItemList();

    // Função utilitária para garantir número
    const safeNumber = (val: any) => {
      if (val === null || val === undefined || val === '' || isNaN(Number(val))) return 0;
      return Number(val);
    };

    const html = `
      <html>
      <head>
        <title>Relatório de Compras</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 40px; }
          h2 { margin-bottom: 0; }
          .summary { margin-bottom: 20px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
          th { background: #f0f0f0; }
        </style>
      </head>
      <body>
        <h2>Relatório de Compras</h2>
        <div class="summary">
          <div><b>Empresa:</b> ${this.salesHistoryCompany.getCorporateName()}</div>
          <div><b>CNPJ:</b> ${this.salesHistoryCompany.getFiscalNumber()}</div>
          <div><b>Colaboradores:</b> ${safeNumber(this.salesHistoryCompany.getEmployeeCount())}</div>
          <div><b>Produtos Vendidos:</b> ${safeNumber(summary.getProductSoldCount())}</div>
          <div><b>Valores Gerados:</b> R$ ${safeNumber(summary.getSalesValueableCount()).toFixed(2)}</div>
          <div><b>Subsídio Praticado:</b> R$ ${safeNumber(summary.getSalesSubsidyValueCount()).toFixed(2)}</div>
          <div><b>Desconto em folha:</b> R$ ${safeNumber(summary.getPaymentrollValueCount()).toFixed(2)}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Medicamento/Produto</th>
              <th>Quantidade</th>
              <th>Região</th>
              <th>Rede</th>
              <th>Valor Gerado</th>
            </tr>
          </thead>
          <tbody>
            ${items.map(item => `
              <tr>
                <td>${item.getProductName()}</td>
                <td>${safeNumber(item.getSoldItemCount())}</td>
                <td>${item.getStateName()}</td>
                <td>${item.getNetworkName()}</td>
                <td>R$ ${safeNumber(item.getSoldValueCount()).toFixed(2)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank', 'width=900,height=700');
    if (printWindow) {
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
      };
      // fallback para browsers que não disparam onload corretamente
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 500);
    }
  }
}
